import { useEffect } from "react";

import { setEnvVariables } from "../../../store/slices/environmentSlice";
import { useTypedDispatch, useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

import { ENV_VARS } from "./utils/constants";

function EnvironmentGuard({ children }: React.PropsWithChildren) {
  const dispatch = useTypedDispatch();

  const { isInitialized } = useTypedSelector((state) => state.environment);

  const initEnvVariables = () => {
    dispatch(setEnvVariables(ENV_VARS));
  };

  useEffect(() => {
    setTimeout(initEnvVariables, 2000);
  }, []);

  return (
    <LoadingContainer isLoading={!isInitialized}>{children}</LoadingContainer>
  );
}

export default EnvironmentGuard;
